<div class="shadow-md relative bg-primary-50 rounded-lg overflow-hidden h-full">
  <div class="relative overflow-hidden rounded-lg">
    <img
      [src]="teamMember().image ?? '/assets/img/hero-temp.png'"
      [alt]="teamMember().name"
      class="w-full h-auto rounded-lg"
    />
  </div>
  <div class="flex flex-col items-center text-center p-4 gap-4">
    <div>
      <h3 class="mb-1 text-2xl text-primary-800">
        {{ teamMember().name }}
      </h3>
      <p class="text-slate-600">{{ teamMember().role }}</p>
    </div>
    <p class="text-slate-600">{{ teamMember().description }}</p>
  </div>
</div>
